import {
  REQUEST_OTP,
  RECEIVE_OTP,
  REGENERATE_OTP,
  RECEIVE_REGENERATE_OTP_RESPONSE,
  RECEIVE_ERROR_OTP_PARAMS,
  RESET_OTP_ERROR,
  RESET_OTP_REDIRECTION,
  RESET_OTP_PARAMS
} from "../actions/otp";

const initialState = {
  otpRedirecting: false,
  otpParams: undefined,
  otpError: undefined
};

export default function otpReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_OTP:
      return { ...state, otpRedirecting: true };
    case RECEIVE_OTP:
      return {
        ...state,
        otpRedirecting: false,
        otpParams: action.otpParams
      };
    case REGENERATE_OTP:
      return { ...state, otpRedirecting: false };
    case RECEIVE_REGENERATE_OTP_RESPONSE:
      return { ...state, otpRedirecting: false, otpParams: action.otpParams };
    case RECEIVE_ERROR_OTP_PARAMS:
      return { ...state, otpRedirecting: false, otpError: action.message };
    case RESET_OTP_REDIRECTION:
      return { ...state, otpRedirecting: false };
    case RESET_OTP_PARAMS:
      return { ...state, otpParams: undefined };
    case RESET_OTP_ERROR:
      return { ...state, otpError: undefined };
    default:
      return state;
  }
}
